<!--
  VProduct

  還原自 index.pretty.js L2158。render function 已轉回 template。

  商品客製化對話框：甜度（必選）、冰塊（必選）、加料（選填）、備註、數量。
  同時服務「新增到購物車」與「編輯既有品項」兩種模式：

    mode = 0  新增   -> 底部按鈕顯示 add_cart，數量最低為 1
    mode = 1  編輯   -> 顯示 update；數量可減到 0，此時按鈕變成 remove

  mode 由 mounted 時 product 有沒有 count 欄位判定 —— 有的話代表是從
  購物車點進來編輯的既有品項。

  必選項未選時不直接送出，而是標紅並把畫面捲動到該區塊
  （捲動偏移量 650px 以上用 175、以下用 140/135，是原始碼的響應式補償）。
-->

<template>
  <div class="bg-overlay align-center d-flex jc-center fd-row p-flex t-0 r-0 b-0 l-0">
    <div
      class="pop-container d-flex p-flex a-center"
      @click="documentClick"
      @scroll="scrollEvent"
    >
      <div ref="popMenu" class="card normal">
        <div class="header-sticky-container" :class="{ show: header_show }">
          <div class="d-flex jc-space">
            <div class="title font-36 m-b-8">
              <p>{{ product.drink }}</p>
            </div>
            <div>
              <i class="font-28 material-icons hover t-gray-7 c-pointer" @click="close">close</i>
            </div>
          </div>
          <div class="t-gray-7 font-14 m-b-8">
            <p>{{ product.drink_describe }}</p>
          </div>
        </div>

        <div class="list-container">
          <!-- 甜度（必選） -->
          <div
            v-if="product.sugar !== null"
            ref="suger"
            class="card-list"
            :class="{ alert: suger_error }"
          >
            <div class="d-flex jc-space p-l-40 p-r-40">
              <div class="font-18"><p>{{ $t('sweetness') }}</p></div>
              <div class="required-label font-16"><p>{{ $t('require') }}</p></div>
            </div>
            <div class="font-14 t-gray-7 p-l-40 p-r-40 m-b-8">
              <p>{{ $t('select_one') }}</p>
            </div>

            <label v-for="(item, rindex) in product.sugar" :key="rindex" :for="item">
              <div class="card-list" :class="label_actived">
                <div class="d-flex p-l-40 p-r-40">
                  <div v-if="enable_order" class="form-check-label">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="item"
                      name="suger"
                      :value="item"
                      :checked="suger_selected === item"
                      @click="suger_selected_event(item)"
                    />
                    <span class="circle"><span class="check"></span></span>
                  </div>
                  <p class="font-18">{{ item }}</p>
                </div>
              </div>
              <div
                v-show="rindex < product.sugar.length - 1"
                class="menu-divider"
              ></div>
            </label>
          </div>

          <!-- 冰塊（必選） -->
          <div
            v-if="product.ice !== null"
            ref="ice"
            class="card-list"
            :class="{ alert: ice_error }"
          >
            <div class="d-flex jc-space p-l-40 p-r-40">
              <div class="font-18"><p>{{ $t('ice_cube') }}</p></div>
              <div class="required-label font-16"><p>{{ $t('require') }}</p></div>
            </div>
            <div class="font-14 t-gray-7 p-l-40 p-r-40 m-b-8">
              <p>{{ $t('select_one') }}</p>
            </div>

            <label v-for="(item, rindex) in product.ice" :key="rindex" :for="item">
              <div class="card-list" :class="label_actived">
                <div class="d-flex p-l-40 p-r-40">
                  <div v-if="enable_order" class="form-check-label">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="item"
                      name="ice"
                      :value="item"
                      :checked="ice_selected === item"
                      @click="ice_selected_event(item)"
                    />
                    <span class="circle"><span class="check"></span></span>
                  </div>
                  <p class="font-18">{{ item }}</p>
                </div>
              </div>
              <div v-show="rindex < product.ice.length - 1" class="menu-divider"></div>
            </label>
          </div>

          <!-- 加料（選填，售完的仍列出但不可選） -->
          <div v-if="product.feeds.length !== 0" ref="feed" class="card-list">
            <div class="d-flex jc-space p-l-40 p-r-40">
              <div class="font-18"><p>{{ $t('ingredients') }}</p></div>
              <div class="optional-label font-16"><p>{{ $t('optional') }}</p></div>
            </div>
            <div class="font-14 t-gray-7 p-l-40 p-r-40 m-b-8">
              <p>{{ $t('select_one') }}</p>
            </div>

            <label v-for="(feed, rindex) in product.feeds" :key="rindex" :for="feed.item">
              <div class="card-list" :class="feed_label_actived(feed)">
                <div class="d-flex jc-space p-l-40 p-r-40">
                  <div class="d-flex">
                    <div v-if="enable_feed(feed)" class="form-check-label">
                      <input
                        class="form-check-input"
                        type="radio"
                        :id="feed.item"
                        name="feed"
                        :value="feed.item"
                        :checked="feed_selected.item === feed.item"
                        @click="feed_selected_event(feed)"
                      />
                      <span class="circle"><span class="check"></span></span>
                    </div>
                    <p class="font-18">{{ feed.item }}</p>
                  </div>

                  <p v-if="feed.feed_sell === 'true'" class="t-gray-7 font-18">
                    +NT${{ feed.feed_price }}
                  </p>
                  <p v-else class="t-gray-7 font-18">{{ $t('sold_out') }}</p>
                </div>
              </div>
            </label>
          </div>

          <!-- 備註 -->
          <div ref="feedback" class="card-list">
            <div class="d-flex jc-space p-l-40 p-r-40">
              <div class="font-18"><p>{{ $t('special_instr') }}</p></div>
              <div class="optional-label font-16"><p>{{ $t('optional') }}</p></div>
            </div>
            <div class="font-14 t-gray-7 p-l-40 p-r-40 m-b-8">
              <p>{{ $t('notes') }}</p>
            </div>
            <div class="p-l-40 p-r-40">
              <v-textarea
                :content="bind_message"
                :disabled="is_close"
                @update="update_message"
              />
            </div>
          </div>
        </div>

        <div class="footer-sticky-container">
          <div class="d-flex jc-space a-center">
            <div
              v-if="is_close === false && product.drink_sell === 'true'"
              class="d-flex jc-space a-center m-r-24"
            >
              <button class="btn btn-grey fab" @click="count_sub">
                <i class="material-icons">remove</i>
              </button>
              <p class="count-label font-18 t-align-center">{{ count }}</p>
              <button class="btn btn-grey fab" @click="count_add">
                <i class="material-icons">add</i>
              </button>
            </div>

            <button v-if="is_close === true" class="btn btn-grey btn-fill" disabled>
              <p class="t-gray-10 font-18">{{ $t('close') }}</p>
            </button>

            <button
              v-else-if="mode === 0 && product.drink_sell === 'false'"
              class="btn btn-grey btn-fill"
              disabled
            >
              <p class="t-gray-10 font-18">{{ $t('sold_out') }}</p>
            </button>

            <button
              v-else-if="btn_remove_actived"
              class="btn btn-primary btn-fill"
              @click="check"
            >
              <p class="t-gray-10 font-18">{{ $t('remove') }}</p>
            </button>

            <button
              v-else
              class="btn btn-primary btn-fill d-flex jc-space a-center"
              @click="check"
            >
              <p class="flex-1 s-screen"></p>
              <p v-if="mode === 0" class="flex-2 t-align-center font-18">{{ $t('add_cart') }}</p>
              <p v-else class="flex-2 t-align-center font-18">{{ $t('update') }}</p>
              <p class="flex-1 t-align-right font-18">NT${{ total_price }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import VTextarea from '@/components/VTextarea.vue'
import { uuid } from '@/utils'

/** 捲動到必選區塊時的偏移補償，寬螢幕與窄螢幕不同 */
const SCROLL_OFFSET_WIDE = 175
const SCROLL_OFFSET_NARROW_SUGER = 140
const SCROLL_OFFSET_NARROW_ICE = 135
const WIDE_SCREEN = 650

export default {
  components: { 'v-textarea': VTextarea },

  props: ['is_close', 'product'],

  data() {
    return {
      mode: 0,
      id: null,
      header_show: false,
      feed_selected: { item: false },
      ice_selected: false,
      suger_selected: false,
      ice_error: false,
      suger_error: false,
      count: 1,
      total_price: this.product.drink_price,
      message: ''
    }
  },

  computed: {
    enable_order() {
      return !this.is_close && this.product.drink_sell === 'true'
    },

    label_actived() {
      return this.is_close || this.product.drink_sell !== 'true' ? '' : 'card-hover'
    },

    /** 編輯模式下把數量減到 0，按鈕就變成「移除」 */
    btn_remove_actived() {
      return !this.is_close && this.count === 0
    },

    bind_message() {
      return this.product.message !== undefined ? this.product.message : ''
    }
  },

  watch: {
    count() {
      this.cal_price()
    },

    feed_selected() {
      this.cal_price()
    }
  },

  methods: {
    ...mapActions(['addItemToCart', 'editItemToCart', 'removeItemToCart']),

    documentClick(event) {
      const menu = this.$refs.popMenu
      if (menu === undefined) return

      const target = event.target
      if (menu !== target && !menu.contains(target)) this.$emit('event', 'order_close')
    },

    scrollEvent(event) {
      this.header_show = event.srcElement.scrollTop > 50
    },

    close() {
      this.$emit('event', 'order_close')
    },

    enable_feed(feed) {
      return !this.is_close && this.product.drink_sell === 'true' && feed.feed_sell === 'true'
    },

    feed_label_actived(feed) {
      return this.enable_feed(feed) ? 'card-hover' : ''
    },

    /** 再點一次已選的加料等於取消 */
    feed_selected_event(feed) {
      this.feed_selected = feed.item === this.feed_selected.item ? { item: false } : feed
    },

    ice_selected_event(value) {
      this.ice_selected = value
      this.ice_error = false
    },

    suger_selected_event(value) {
      this.suger_selected = value
      this.suger_error = false
    },

    update_message(value) {
      this.message = value
    },

    count_sub() {
      // 新增模式最低 1 杯；編輯模式可以減到 0（等同移除）
      const min = this.mode === 0 ? 1 : 0
      if (this.count > min) this.count--
    },

    count_add() {
      this.count++
    },

    cal_price() {
      const feedPrice = this.feed_selected.item !== false ? this.feed_selected.feed_price : 0
      this.total_price = (this.product.drink_price + feedPrice) * this.count
    },

    /** 把畫面捲到指定的必選區塊 */
    scrollToRef(ref, narrowOffset) {
      const top = this.$refs[ref].getBoundingClientRect().top
      const offset = window.innerWidth > WIDE_SCREEN ? SCROLL_OFFSET_WIDE : narrowOffset
      document.getElementsByClassName('pop-container')[0].scrollTop += top - offset
    },

    check() {
      // 數量歸零 = 從購物車移除
      if (this.count === 0) {
        this.removeItemToCart(this.product.id)
        this.$emit('event', 'update_cart')
        return
      }

      if (this.product.sugar !== null && !this.suger_selected) {
        this.suger_error = true
        this.scrollToRef('suger', SCROLL_OFFSET_NARROW_SUGER)
      }

      if (this.product.ice !== null && !this.ice_selected) {
        this.ice_error = true
        // 甜度也沒選時優先捲到甜度，不重複捲動
        if (!this.suger_error) this.scrollToRef('ice', SCROLL_OFFSET_NARROW_ICE)
      }

      if (this.suger_error || this.ice_error) return

      const item = {
        id: this.id === null ? uuid() : this.id,
        drink: this.product.drink,
        drink_id: this.product.drink_id,
        drink_image: this.product.drink_image,
        drink_price: this.product.drink_price,
        drink_sell: this.product.drink_sell,
        drink_describe: this.product.drink_describe,
        feeds: this.product.feeds,
        feed_selected: this.feed_selected.item === false ? null : this.feed_selected,
        ice: this.product.ice,
        ice_selected: this.ice_selected === false ? null : this.ice_selected,
        sugar: this.product.sugar,
        suger_selected: this.suger_selected === false ? null : this.suger_selected,
        count: this.count,
        total_price: this.total_price,
        message: this.message
      }

      if (this.mode === 0) {
        this.addItemToCart(item)
      } else {
        this.editItemToCart(item)
      }

      this.$emit('event', 'update_cart')
    }
  },

  created() {},

  destroyed() {},

  mounted() {
    // product 帶 count 代表是從購物車點進來編輯既有品項
    if (this.product.count === undefined) return

    this.mode = 1
    this.id = this.product.id
    this.feed_selected =
      this.product.feed_selected === null ? { item: false } : this.product.feed_selected
    this.ice_selected = this.product.ice_selected !== null && this.product.ice_selected
    this.suger_selected = this.product.suger_selected !== null && this.product.suger_selected
    this.ice_error = this.product.ice_error
    this.suger_error = this.product.suger_error
    this.count = this.product.count
    this.total_price = this.product.total_price
    this.message = this.product.message
  }
}
</script>
